import { disableScroll } from "../functions/disable-scroll";
import { enableScroll } from "../functions/enable-scroll";

document.addEventListener("DOMContentLoaded", () => {
  const filter = document.querySelector("#sibebar-shop");
  if (filter) {
    // Добавляю кнопку закрытия
    const filterCloseHTML = `<button id="filter-close" class="sibebar-shop__close button-reset">&times;</button>`;
    filter.insertAdjacentHTML("beforeend", filterCloseHTML);

    // Открываю по клику
    const filterTrigger = document.getElementById("filter-trigger");
    filterTrigger.addEventListener("click", (e) => {
      e.preventDefault();
      filter.classList.add("sibebar-shop--active");
      disableScroll();
    });

    // Закрытие фильтра
    const filterCloseEl = document.getElementById("filter-close");
    filterCloseEl.addEventListener("click", (e) => {
      e.preventDefault();
      filter.classList.remove("sibebar-shop--active");
      enableScroll();
    });
  }
});
